  import Swiper from './swiper-bundle.esm.browser.min.js';

  document.querySelectorAll('.new_faq_wpr').forEach((section) => {
    const items = section.querySelectorAll('.new_faq_col');

    items.forEach((item) => {
      const title = item.querySelector('.new_faq_col_title');
      const info = item.querySelector('.new_faq_col_info');

      title.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        if (isActive) {
          // Close current
          info.style.maxHeight = null;
          item.classList.remove('active');
        } else {
          // Close all others
          section.querySelectorAll('.new_faq_col.active').forEach((openItem) => {
            if (openItem !== item) {
              const openInfo = openItem.querySelector('.new_faq_col_info');
              openInfo.style.maxHeight = null;
              openItem.classList.remove('active');
            }
          });

          // Open clicked
          info.style.maxHeight = info.scrollHeight + 'px';
          item.classList.add('active');
        }
      });
    });
  });

  document.querySelectorAll('.new_review_slider').forEach((slider) => {
    // get current slider wrapper
    const wrapper = slider.closest('.new_review_slider_wrapper');

    new Swiper(slider, {
      loop: true,
      spaceBetween: 25,

      pagination: {
        el: wrapper.querySelector('.new_review_pagination'),
        clickable: true,
      },

      navigation: {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  document.querySelectorAll('.new_accordion_title').forEach((title) => {
    title.addEventListener('click', () => {
      const item = title.closest('.new_accordion_item');
      const content = item.querySelector('.new_accordion_content_wp');

      // close other accordions
      document.querySelectorAll('.new_accordion_item').forEach((accordion) => {
        if (accordion !== item) {
          accordion.classList.remove('active');

          const otherContent = accordion.querySelector('.new_accordion_content_wp');
          otherContent.style.maxHeight = null;
        }
      });

      // toggle current accordion
      item.classList.toggle('active');

      if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = null;
      }
    });
  });

  document.querySelectorAll('.main_hero_slider').forEach((slider) => {
    const parent = slider.parentElement;

    new Swiper(slider, {
      spaceBetween: 0,
      effect: 'fade',
      loop: true,

      // autoplay: {
      //   delay: 3500,
      // },

      navigation: {
        nextEl: parent.querySelector('.swiper-button-next.main_hero_arrow'),
        prevEl: parent.querySelector('.swiper-button-prev.main_hero_arrow'),
      },

      pagination: {
        el: parent.querySelector('.swiper-pagination.main_hero_pagination'),
        clickable: true,
      },
    });
  });

  document.querySelectorAll('.home_journal_slider').forEach((slider) => {
    const section = slider.closest('section') || slider.parentElement;

    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 20,

      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },

      navigation: {
        nextEl: section.querySelector('.home_journal_arrow.swiper-button-next'),
        prevEl: section.querySelector('.home_journal_arrow.swiper-button-prev'),
      },

      breakpoints: {
        0: {
          slidesPerView: 1.2,
        },

        768: {
          slidesPerView: 3,
        },
      },
    });
  });

  document.querySelectorAll('.quality_col_block').forEach(function (block) {
    block.addEventListener('click', function () {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        document.querySelectorAll('.quality_col_block').forEach(function (item) {
          item.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.nt26-reviews-swiper').forEach((slider) => {
    const section = slider.closest('.claimed_video_section');
    let soundOn = false;

    const getCards = () => slider.querySelectorAll('.nt26-reel__card');

    function stopVideos() {
      getCards().forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;

        video.pause();
        video.currentTime = 0;
        video.muted = !soundOn;
        card.classList.remove('is-playing');
      });
    }

    function playActiveVideo() {
      const card = slider.querySelector('.swiper-slide-active .nt26-reel__card');
      const video = card?.querySelector('video');

      if (!video) return;

      video.muted = !soundOn;
      video
        .play()
        .then(() => card.classList.add('is-playing'))
        .catch(() => card.classList.remove('is-playing'));
    }

    const swiper = new Swiper(slider, {
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      grabCursor: true,
      speed: 650,
      slidesPerView: 'auto',
      initialSlide: 3,
      preventClicks: false,
      preventClicksPropagation: false,

      navigation: {
        nextEl: section?.querySelector('.swiper-button-next.nt26-reviews-arrow'),
        prevEl: section?.querySelector('.swiper-button-prev.nt26-reviews-arrow'),
      },

      on: {
        init: playActiveVideo,
        slideChangeTransitionStart: stopVideos,
        slideChangeTransitionEnd: playActiveVideo,
        touchStart: stopVideos,
      },
    });

    slider.addEventListener('click', (event) => {
      const card = event.target.closest('.nt26-reel__card');
      if (!card) return;

      const slide = card.closest('.swiper-slide');
      const video = card.querySelector('video');

      if (!slide) return;

      if (!slide.classList.contains('swiper-slide-active')) {
        swiper.slideToLoop(Number(slide.dataset.swiperSlideIndex));
        return;
      }

      if (!video) return;

      if (video.paused) {
        video.muted = !soundOn;
        video.play();
        card.classList.add('is-playing');
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });

    const soundButton = section?.querySelector('#nt26SoundToggle');
    const soundText = section?.querySelector('#nt26SoundText');
    const soundIcon = section?.querySelector('#nt26SoundIcon');

    soundButton?.addEventListener('click', () => {
      soundOn = !soundOn;

      const video = slider.querySelector('.swiper-slide-active video');
      const card = slider.querySelector('.swiper-slide-active .nt26-reel__card');

      if (video) {
        video.muted = !soundOn;
        if (soundOn) video.play().catch(() => {});
        card?.classList.toggle('is-playing', soundOn);
      }

      soundText.textContent = soundOn ? 'SOUND ON' : 'SOUND OFF';

      soundIcon.innerHTML = soundOn
        ? `<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
         <path d="M19 9a5 5 0 0 1 0 6"></path>
         <path d="M22 7a9 9 0 0 1 0 10"></path>`
        : `<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
         <line x1="23" y1="9" x2="17" y2="15"></line>
         <line x1="17" y1="9" x2="23" y2="15"></line>`;
    });

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stopVideos() : playActiveVideo();
    });
  });
  document.querySelectorAll('.home_doctors_section').forEach((section) => {
    const imageEl = section.querySelector('.home_doctors_slider_main');
    const contentEl = section.querySelector('.home_doctors_content_slider');

    if (!imageEl || !contentEl) return;

    const imageSlider = new Swiper(imageEl, {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      speed: 600,
      allowTouchMove: false,
    });

    const contentSlider = new Swiper(contentEl, {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      speed: 600,

      pagination: {
        el: section.querySelector('.home_doctors_pagination'),
        type: 'fraction',

        formatFractionCurrent(number) {
          return ('0' + number).slice(-2);
        },

        formatFractionTotal(number) {
          return ('0' + number).slice(-2);
        },
      },

      navigation: {
        nextEl: section.querySelector('.home_doctors_arrow.swiper-button-next'),
        prevEl: section.querySelector('.home_doctors_arrow.swiper-button-prev'),
      },

      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
    });

    contentSlider.on('slideChange', () => {
      imageSlider.slideTo(contentSlider.activeIndex);
    });
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute('href').replace(/^#/, '');
    const target = document.getElementById(id);

    if (!target) return;

    e.preventDefault();

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  });
  

document.addEventListener('DOMContentLoaded', function () {

  const menuBtn = document.querySelector('.custom_header_menu_btn');
  const overlay = document.querySelector('.custom_header_overlay');

  if (!menuBtn) return;

  // Menu button click
  menuBtn.addEventListener('click', function () {
    document.body.classList.toggle('megamenu-open');
  });

  // Overlay click - close menu
  if (overlay) {
    overlay.addEventListener('click', function () {
      document.body.classList.remove('megamenu-open');
    });
  }

});

document.querySelectorAll('.review-slider').forEach((slider) => {
  const section = slider.closest('section');

  new Swiper(slider, {
    loop: true,
    spaceBetween: 20,

    navigation: {
      nextEl: section.querySelector('.swiper-button-next'),
      prevEl: section.querySelector('.swiper-button-prev'),
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
      },

      450: {
        slidesPerView: 1.5,
      },

      768: {
        slidesPerView: 2.5,
      },

      1024: {
        slidesPerView: 4,
      },
    },
  });
});